import {
  Colors,
  convertHexToBackgroundColorKeys,
  convertHexToContentColorKeys,
  Flex,
  IconChevronRight,
  RemoteImage,
  Typography,
} from '@banhala/ui-kit';
import type {
  PromotionShortBannerEntity,
  PromotionShortBannerProps,
} from './types';
import { isNotNil } from '../../../../utils';
import { useGuardedScreenWidth, useOpenDeeplink } from '../../../../hooks';
import { LoopScrollCarousel } from '../../../LoopScrollCarousel';
import { RemainTimer } from './components/RemainTimer';
import { useLogClickShortBanner } from './hooks/useLogClickShortBanner';

export const PromotionShortBanner = ({
  entity,
  logging,
}: PromotionShortBannerProps) => {
  const screenWidth = useGuardedScreenWidth('PromotionShortBanner');
  const logClickShortBanner = useLogClickShortBanner(logging);
  const { openDeeplink } = useOpenDeeplink();

  if (!entity || entity.length === 0) return null;
  if (!screenWidth) return null;

  return (
    <LoopScrollCarousel<PromotionShortBannerEntity>
      data={entity}
      width={screenWidth}
      height={32}
      autoPlay={entity.length > 1}
      autoPlayInterval={3000}
      renderItem={({ item }) => (
        <Flex.Row
          backgroundColor={
            convertHexToBackgroundColorKeys(item.item.background_color) ??
            undefined
          }
          backgroundColorValue={
            convertHexToBackgroundColorKeys(item.item.background_color)
              ? undefined
              : item.item.background_color
          }
          alignItems={'center'}
          justifyContent={'center'}
          padding={{ horizontal: 16 }}
          height={32}
          gap={2}
          onPress={() => {
            if (isNotNil(item.item.deeplink)) {
              logClickShortBanner(item);
              openDeeplink(item.item.deeplink);
            }
          }}
        >
          <Flex.Row gap={4} alignItems={'center'}>
            <RemoteImage uri={item.item.icon} width={20} height={20} />
            <Typography
              type={'subtitle4'}
              color={
                convertHexToContentColorKeys(item.item.text_color) ?? undefined
              }
              rawColor={
                convertHexToContentColorKeys(item.item.text_color)
                  ? undefined
                  : item.item.text_color
              }
            >
              {item.item.text}
            </Typography>
            {isNotNil(item.item.timer) && (
              <RemainTimer timer={item.item.timer} />
            )}
          </Flex.Row>
          {isNotNil(item.item.deeplink) && (
            <IconChevronRight
              size={16}
              fill={item.item.arrow_color ?? Colors.content_tertiary}
            />
          )}
        </Flex.Row>
      )}
    />
  );
};
